import axios from "axios"

// API URL Configuration:
// - Local: Empty string "" (uses proxy from package.json)
// - Dev/Prod: Set via REACT_APP_API_URL environment variable (from GitLab pipeline)
const apiUrl = process.env.REACT_APP_API_URL || ""

const URLactionForm = `${apiUrl}/public/projects/GetProjectForm`

const URLmainPageData2 = `${apiUrl}/public/municipality`

const URLaddProject = `${apiUrl}/public/projects`

const URLgetCities = `${apiUrl}/public/cities` 

const URLeditProject = `${apiUrl}/public/projects`

const URLsendFeedback = `${apiUrl}/public/feedback`

const URLgetFeedback = `${apiUrl}/public/feedback`

const getMunicForm = () => {
    return axios.get(URLactionForm)
}

const getMainPageData2 = (locationIdent) => {
    return axios.get(`${URLmainPageData2}/${locationIdent}`)
}

const addProject = (municipalityProject, locationIdent) => {
    return axios.post(`${URLaddProject}/${locationIdent}`, municipalityProject)
}

const editProject = (municipalityProject, projectId, locationIdent) => {
    return axios.put(`${URLeditProject}/${locationIdent}/${projectId}`, municipalityProject)
}

const sendFeedbackFinal = (feedbackObj, locationIdent, projectId) => {
    return axios.post(`${URLsendFeedback}/${locationIdent}/${projectId}`, feedbackObj)
}

const getFeedbackFinal = (projectId, locationIdent) => {
    return axios.get(`${URLgetFeedback}/${locationIdent}/${projectId}`)
}

const getCities = () => {
    return axios.get(URLgetCities)
}
 
export { getMunicForm, addProject, editProject,
         sendFeedbackFinal, getFeedbackFinal, getMainPageData2, getCities}